export default "__VITE_ASSET__D_K9tsgp__"